<template>
    <div class="login-body">
        <div class="login-left">
            <div class="header">
                <p>Spotlight - 报告生产平台</p>
                <!--<img src="../assets/images/cwooLogo.svg" alt="">-->
            </div>
        </div>
        <div class="login-right">
            <el-form
                class="login-form"
                ref="form"
                :rules="rules"
                :model="form"
                label-width="80px"
            >
                <h2 class="login-title">登录</h2>
                <div class="login-input">
                    <el-form-item prop="mobile">
                        <el-input
                            v-model="form.mobile"
                            prop="mobile"
                            placeholder="请输入企业微信注册手机号"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="login-input code-input">
                    <el-form-item prop="password">
                        <el-input
                            v-model="form.password"
                            prop="password"
                            placeholder="请输入验证码"
                            show-password
                        ></el-input>
                        <el-button
                            :class="[defaultShow ? '' : 'gary']"
                            type="primary"
                            @click="getCode()"
                        >{{content}}
                        </el-button>
                    </el-form-item>
                </div>
                <el-button
                    class="login-btn"
                    type="primary"
                    @click="submitForm('form')"
                >登录
                </el-button>
            </el-form>
            <div class="footer">
                © 北京智慧星光信息技术股份有限公司
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/login.css"
    import {goLogin, getAccountInfo, getCode } from '@r/api'

    let Base64 = require('js-base64').Base64

    export default {
        data() {
            return {
                form: {
                    mobile: "",
                    password: "",
                    remember: false
                },
                rules: {
                    mobile: [{required: true, message: '请输入企业微信注册手机号', trigger: 'blur'}],
                    password: [{required: true, message: '请输入验证码', trigger: 'blur'}],
                },
                canSubmit: true, //解决多次点击触发接口请求的问题
                content:'获取验证码',
                totalTime: 60,
                defaultShow: true
            }
        },
        created() {
            // 在页面加载时从cookie获取登录信息
            let mobile = this.$cookies.get("mobile")
            let password = this.$cookies.get("password")
            password = password && Base64.decode(password) || ''
            mobile = mobile || localStorage.getItem('_mobile')
            // 如果存在赋值给表单，并且将记住密码勾选
            this.form.mobile = mobile
            if (password) {
                this.form.password = password
                this.form.remember = true
            }
        },
        mounted() {
            document.addEventListener("keyup", this.keyupHandle)
        },
        destroyed() {
            document.removeEventListener("keyup", this.keyupHandle)
        },
        methods: {
            getCode(){
                if(!this.defaultShow) {
                    return;
                }
                let pat = /^1[0-9]{10}$/;
                if (this.form.mobile == '' || this.form.mobile== undefined) {
                    this.$message.error('手机号不能为空');
                    return;
                }
                if (!pat.test(this.form.mobile) && this.form.mobile != '') {
                    //手机号不对
                    this.$message.error('手机号不正确');
                    return;
                }
                this.content = this.totalTime + 's后重新发送' //
                this.defaultShow = false
                let clock = window.setInterval(() => {

                    this.totalTime--

                    this.content = this.totalTime + 's后重新发送'

                    if (this.totalTime < 0) {    //当倒计时小于0时清除定时器

                        window.clearInterval(clock)

                        this.content = '获取验证码'

                        this.totalTime = 60
                        this.defaultShow = true
                    }

                },1000)
                getCode({
                    'mobile': this.form.mobile
                }).then(data => {
                    this.$message.success('发送成功！请前往企业微信查看')

                }, err => {
                    let errMsg = err && err.header && err.header.msg || '手机号不正确'
                    this.$message.error(errMsg);
                })
            },
            submitForm() {
                if (!this.canSubmit) {
                    return
                }
                this.canSubmit = false
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        goLogin({
                            'mobile': this.form.mobile,
                            'checkCode': this.form.password
                        }).then(data => {
                            if (data) {
                                // 储存登录信息
                                localStorage.setItem('_mobile', this.form.mobile)
                                this.getAccountInfo().then(() => {
                                    this.$store.commit('menuIndex', 'dashboard')
                                    this.canSubmit = false

                                    this.$router.push({path: "/dashboard"})
                                }).catch(() => {
                                    this.$message.error('获取用户信息失败')
                                })
                                // getUserInfoByCookie({}).then(data => {
                                //     if (data) {
                                //         this.canSubmit = false
                                //         //存储 userInfo
                                //         this.$cookies.remove('user_info')
                                //         this.$cookies.set('user_info', JSON.stringify(data.info))
                                //         this.$router.push({path: "/reportDetail"})
                                //     } else {
                                //         this.canSubmit = true
                                //     }
                                // }, err => {
                                //     this.canSubmit = true
                                //     let errMsg = err && err.header && err.header.msg || '获取用户信息失败'
                                //     this.$message.error(errMsg);
                                // })
                            }
                        }, err => {
                            this.canSubmit = true
                            let errMsg = err && err.header && err.header.msg || '手机号或验证码不正确'
                            this.$message.error(errMsg);
                        })
                    } else {
                        this.canSubmit = true
                        console.error("error submit!!")
                        return false
                    }
                })
            },
            // 获取用户信息
            getAccountInfo(){
                return new Promise((resolve, reject) => {
                    getAccountInfo({}).then(data => {
                        if (data && data.info) {
                            this.$cookies.remove('user_info')
                            this.$cookies.set('user_info', JSON.stringify(data.info))
                        }
                        resolve()
                    }).catch(() => {
                        reject()
                    })
                })
            },
            keyupHandle(e) {
                if (e.keyCode === 13) {
                    this.submitForm()
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/login.vue